import { Outlet } from "react-router-dom";
import { PageHeader } from "@/components/ui/PageHeader";
import { Tabs, type TabItem } from "@/components/ui/Tabs";
import { useIsAdmin } from "@/hooks/useCurrentUser";

const BASE_TABS: TabItem[] = [
  { to: "/leads", label: "List", end: true },
  { to: "/leads/map", label: "Map" },
];

export function LeadsLayout() {
  const isAdmin = useIsAdmin();
  const tabs: TabItem[] = isAdmin
    ? [...BASE_TABS, { to: "/leads/import", label: "Import" }]
    : BASE_TABS;

  return (
    <div>
      <PageHeader
        title="Leads"
        description="Your address book — import, filter, and zone."
      />
      <Tabs items={tabs} />
      <div className="px-4 py-4 sm:px-8 sm:py-6">
        <Outlet />
      </div>
    </div>
  );
}
